import {
    FLOW_STEP_DATE,
    FLOW_STEP_PRODUCT,
    FLOW_STEP_VEHICLE,
    FLOW_STEP_REVIEW,
    FLOW_STEP_EVENT,
} from 'subscription-flow/constants'

export const GET_RATES = 'GET_BOOKING_RATES'
export const SET_RATES = 'SET_BOOKING_RATES'

export const SELECT_RATE = 'SELECT_RATE'
export const CLEAR_SELECTED_RATE = 'CLEAR_SELECTED_RATE'
export const SET_SELECTED_RATE_DETAILS = 'SET_SELECTED_RATE_DETAILS'
export const FETCH_EVENT_RATE = 'FETCH_EVENT_RATE'
export const SET_SELECTED_VEHICLE = 'SET_SELECTED_VEHICLE'
export const REMOVE_FROM_SELECTED_VEHICLES = 'REMOVE_FROM_SELECTED_VEHICLES'
export const SET_SELECTED_CREDIT_CARD = 'SET_SELECTED_CREDIT_CARD'

export const SET_LAST_BOOKING_DETAILS = 'SET_LAST_BOOKING_DETAILS'
export const CLEAR_LAST_BOOKING_DETAILS = 'CLEAR_LAST_BOOKING_DETAILS'

export const GET_BOOKING_LOCATION_DETAILS = 'GET_BOOKING_LOCATION_DETAILS'
export const SET_BOOKING_LOCATION_DETAILS = 'SET_BOOKING_LOCATION_DETAILS'

export const REDEEM_PROMO_CODE = 'REDEEM_PROMO_CODE'
export const REDEEMED_PROMO_CODE = 'REDEEMED_PROMO_CODE'
export const REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE'
export const SET_AUTO_RENEW = 'SET_AUTO_RENEW'
export const SET_RAW_PROMO_CODE = 'SET_RAW_PROMO_CODE'
export const LAST_BOOKING_REMOVE_PROMO_CODE = 'LAST_BOOKING_REMOVE_PROMO_CODE'

export const ENABLE_CARD = 'ENABLE_CARD'

export const EXIT_BOOKING_FLOW = 'EXIT_BOOKING_FLOW'

export const SELECT_SEASON_TICKET = 'SELECT_SEASON_TICKET'
export const RECEIVED_SELECTED_SEASON_TICKET_RATE = 'RECEIVED_SELECTED_SEASON_TICKET_RATE'
export const SET_PARKING_MODE = 'SET_PARKING_MODE'

export const RECEIVED_WAITING_LIST_RATE = 'RECEIVED_WAITING_LIST_RATE'

// These values are compared to the ones coming from API
export const SHOW_HOURLY_FLOW = ['PNW', 'RAD']
export const SHOW_HOURLY_FLOW_PARK_NOW = 'PNW'
export const SHOW_HOURLY_FLOW_BOOK_IN_ADVANCE = 'RAD'
export const SHOW_MONTHLY_FLOW = ['MNY']
export const SHOW_EVENTS_FLOW = 'EVT'
export const SHOW_PREPAID_FLOW = ['PPC']

export const SET_CURRENT_CUSTOMER_FLOW = 'SET_CURRENT_CUSTOMER_FLOW'
export const RESERVATION_IN_PROGRESS = 'INPROGRESS'

export const BOOKING_FLOW_HEADER_PREFIX = 'booking'

export const BOOKING_FLOW = [FLOW_STEP_DATE, FLOW_STEP_PRODUCT, FLOW_STEP_VEHICLE, FLOW_STEP_REVIEW]

export const EVENT_FLOW = [FLOW_STEP_EVENT, FLOW_STEP_VEHICLE, FLOW_STEP_REVIEW]

export const BOOKING_FLOW_NON_BOOKABLE = [FLOW_STEP_DATE, FLOW_STEP_PRODUCT]

export const GET_UPSELL_OPTIONS = 'GET_UPSELL_OPTIONS'
export const SET_UPSELL_OPTIONS = 'SET_UPSELL_OPTIONS'
export const FAILED_TO_FETCH_UPSELL_OPTIONS = 'FAILED_TO_FETCH_UPSELL_OPTIONS'
export const UPGRAGE_UPSELL_RATE = 'UPGRAGE_UPSELL_RATE'
export const SELECT_UPSELL_RATE = 'SELECT_UPSELL_RATE'
export const CLEAR_SELECTED_UPSELL_RATE = 'CLEAR_SELECTED_UPSELL_RATE'

export const GET_LOCATION_DATA_BY_ID = 'GET_LOCATION_DATA_BY_ID'

export const GET_ADDITIONAL_PARKING_ITEMS = 'GET_ADDITIONAL_PARKING_ITEMS'
export const SET_ADDITIONAL_PARKING_ITEMS = 'SET_ADDITIONAL_PARKING_ITEMS'
export const GET_ADDITIONAL_PARKING_ITEMS_ERROR = 'GET_ADDITIONAL_PARKING_ITEMS_ERROR'

export const CREDIT_CARD_PAYMENT_METHOD = 'Credit card'

export const VERIFY_3DS = 'VERIFY_3DS'
export const DISCARD_3DS = 'DISCARD_3DS'
export const CHALLENGE_3DS = 'CHALLENGE_3DS'

export const STATUS_3DS_SUCCESS = 'SUCCESS'
export const STATUS_3DS_FAILURE = 'FAILURE'
export const STATUS_3DS_CLOSED = 'CLOSED'

export const SET_GUEST_USER_PERSONAL_DETAILS = 'SET_GUEST_USER_PERSONAL_DETAILS'
export const VERIFY_GUEST_USER_SUCCESS = 'VERIFY_GUEST_USER_SUCCESS'
export const VERIFY_GUEST_USER_FAILED = 'VERIFY_GUEST_USER_FAILED'
export const VERIFY_GUEST_USER_RESET = 'VERIFY_GUEST_USER_RESET'

export const MAKE_PURCHASE = 'MAKE_PURCHASE'
export const PURCHASE_COMPLETED = 'PURCHASE_COMPLETED'
export const CLEAR_PURCHASE_COMPLETED = 'CLEAR_PURCHASE_COMPLETED'
export const EXTEND_PURCHASE_COMPLETED = 'EXTEND_PURCHASE_COMPLETED'
export const PURCHASE_ERROR = 'PURCHASE_ERROR'

export const GET_PSE_PAYMENT_BANKS = 'GET_PSE_PAYMENT_BANKS'
export const SET_PSE_PAYMENT_BANKS = 'SET_PSE_PAYMENT_BANKS'
export const RESET_BOOKING_STATE = 'RESET_BOOKING_STATE'
